import { Reveal } from "./Reveal";

export function SectionHeading({ overline, title, subtitle, align = "left", light = false }) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-2xl ${alignment}`}>
      {overline && (
        <p className={`overline mb-3 ${light ? "text-accent" : ""}`}>{overline}</p>
      )}
      <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight text-balance ${light ? "text-white" : "text-foreground"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-muted-foreground"}`}>
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}
